import axios from "axios";
import { INTERNAL_API_URL } from "../index";

export const GET_REPORT_URL = "Reports/GetReport";

export function getReport(data) {
  return axios.post(INTERNAL_API_URL + GET_REPORT_URL, data, { responseType: "blob" });
}
